import { Injectable } from "@angular/core";
import { Observable } from "../../../node_modules/rxjs/Observable";
import { environment } from "../../environments/environment";
import { AuditDetail } from "../models/auditDetail.model";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class UserDetailsService {
  private readonly timeout: number = 30000;
  private readonly basePath: string = "ServiceEvent";

  constructor(
    private http: HttpClient,
    private baseService: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async getUserDetails(
    clientId: string,
    applicationReference: number
  ): Promise<AuditDetail> {
    let uri = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/AuditHistory/AuditDetail/${applicationReference}`;
    let response = await this.http
      .get(uri, { headers: this.baseService.getHeaders() })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          uri
        );
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-details.service.ts